import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate("/admin", { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-charcoal grain flex items-center justify-center px-6">
      <div className="w-full max-w-md relative z-10">
        <Link to="/" className="flex flex-col leading-none mb-12">
          <span className="font-display font-black text-3xl tracking-tight text-toga">TOGA</span>
          <span className="text-[9px] tracking-[0.3em] uppercase text-cream/60 font-bold">Admin Console</span>
        </Link>
        <h1 className="font-display font-black uppercase tracking-tight text-cream text-4xl leading-none">Sign in</h1>
        <form onSubmit={submit} data-testid="login-form" className="mt-10 space-y-7">
          <input data-testid="login-email" type="email" className="line-input !text-cream !border-cream/25 placeholder:!text-cream/40" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="login-password" type="password" className="line-input !text-cream !border-cream/25 placeholder:!text-cream/40" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          {error && <p data-testid="login-error" className="text-toga text-sm">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-toga text-white px-8 py-4 text-xs uppercase tracking-[0.18em] font-bold hover:bg-cream hover:text-charcoal transition-colors duration-300 disabled:opacity-60">
            {loading ? "Signing in…" : "Enter Console"}
          </button>
        </form>
      </div>
    </div>
  );
}
